/** Mirrors server `EQUIPMENT_PERMISSIONS`. Fleet status (EQ-S01) is not the shop availability key. */
export const EQUIPMENT_PERMISSIONS = {
  fleetStatusSet: 'equipment:fleet_status_set',
  availabilitySet: 'equipment:availability_set',
  transferForemanArea: 'fleet.transferForemanArea',
  /** Request a service-area transfer (approvals, then Finance). */
  transferServiceArea: 'fleet.transferServiceArea',
  /** Move a unit between service areas at once. Admins only, for corrections. */
  transferServiceAreaDirect: 'fleet.transferServiceAreaDirect',
  editRoadClass: 'fleet.editRoadClass',
  editRate: 'fleet.editRate',
  /** View Repairs: Defects, PM History, Repair History (with hours and rate), Critical Defects. */
  repairsView: 'equipment:repairs_view',
  /** Manage Repairs: defects, sign-off, Next CVIP, odometer correction, the Equipment badge. */
  repairsManage: 'equipment:repairs_manage',
  vehicleEdit: 'vehicle:edit',
  vehicleCreate: 'vehicle:create',
  vehicleView: 'vehicle:view'
} as const;

/** Finance: mark an approved transfer complete once it is in Sage. */
export const TRANSFER_COMPLETE_PERMISSION = 'equipment:transfer_complete';
/** Transfer settings and reassigning approvers. Held by no role; admins have it as superusers. */
export const TRANSFER_ADMIN_PERMISSION = 'equipment:transfer_admin';

/** Rate-class UI stays in code but off for day one (EQ-R05). */
export const RATE_CLASSES_ENABLED = false;

export const VISIBILITY_FAIL_LABELS: Record<string, string> = {
  fleet_status: 'Equipment status is not Active',
  availability: 'Unit is not in service',
  insurance: 'Insurance is not current'
};
